import type { Tenant, User } from '@lensora/shared'
import { useQuery } from '@tanstack/react-query'


import { api } from '@/lib/api'
import { useAuth } from '@/providers/auth-provider'

export type MeResponse = { user: User; tenant: Pick<Tenant, 'id' | 'slug' | 'name' | 'featureFlags'> | null }

export function useMe() {
  const auth = useAuth()
  const isAuthenticated = auth.status === 'authenticated'

  return useQuery({
    queryKey: ['me'],
    queryFn: () => api.get<MeResponse>('/api/auth/me'),
    enabled: isAuthenticated,
    staleTime: 1000 * 60 * 10,
  })
}

// Self-serve customers are client-role users in the shared "app" tenant who
// manage their own subscription; client-role users in dedicated agency
// tenants do not. Billing UI must key off this, not the tenant-admin
// `billing_enabled` flag, which billing's client-scope webhooks never write.
export function isSelfServeClient(me: MeResponse | undefined): boolean {
  return me?.user.role === 'client' && me?.tenant?.slug === 'app'
}
